import { render } from "./resetView.vue?vue&type=template&id=49d355cc"
import script from "./resetView.vue?vue&type=script&lang=js"
export * from "./resetView.vue?vue&type=script&lang=js"

import exportComponent from "/home/marc/E09/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__